var blockedDates = [
  "2025-08-02",
  "2025-08-23",
  "2025-12-30",
  "2025-12-31",
  "2026-01-01",
  "2026-01-02",
  "2026-01-03",
  "2026-01-04",
  "2026-01-05",
  "2026-01-06",
  "2026-01-07",
  "2026-01-08",
  "2026-01-09",
  "2026-01-10",
  "2026-02-02",
  "2026-02-03",
  "2026-02-13",
  "2026-04-30",
  "2026-02-14",
  "2026-05-07",
  "2026-05-08",
  "2026-05-09",
  "2026-05-01",
  "2026-05-11",
  "2026-09-14",
  "2026-09-15",
  "2026-09-18",
  "2026-09-19",
  "2026-10-17",
  "2026-10-19",
  "2026-10-20",
  "2026-10-24",
  "2026-10-30",
  "2026-10-31",
  "2026-11-16",
  "2026-11-17",
];
var limitedTimeDates = [ 
  "2026-01-06",
  "2026-01-07",
  "2026-01-08",
  "2026-01-09",
  "2026-01-10",
  "2026-01-11",
  "2026-01-12",
  "2026-01-13",
  "2026-01-14",
  "2026-01-15",
  "2026-04-19",
  "2026-04-20",
  "2026-04-21",
  "2026-04-22",
  "2026-04-23",
  "2026-04-24",
  "2026-04-25",
  "2026-04-26",
  "2026-04-27",
  "2026-04-28",
  "2026-04-29",
  "2026-04-30",
  "2026-04-31",
  "2026-05-01",
  "2026-05-11",
  "2026-09-14",
  "2026-09-15",
  "2026-09-18",
  "2026-09-19",
  "2026-10-17",
  "2026-10-19",
  "2026-10-20",
  "2026-10-24",
  "2026-10-30",
  "2026-10-31",
  "2026-11-16",
  "2026-11-17",
];
